var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"options__item corp-orange"},[_c('router-link',{staticClass:"d-flex align-items-center justify-content-start options__link--primary",attrs:{"to":{ name: _vm.to }}},[(!!_vm.icon && _vm.icon.length)?_c('i',{class:_vm.itemClass}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.label))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }